<app-page-container>
  <div class="container">
    <ng-lottie height="200px" [options]="options" (animationCreated)="animationCreated($event)"></ng-lottie>
    <div class="text">
      <h2>Você não tem acesso aos módulos do sistema!</h2>
      <h5>Fale com o responsável para resolver esta situação</h5>
    </div>
    <button class="button-primary" (click)="sair()">Sair</button>
  </div>
</app-page-container>
